import { createContext } from 'react';
import { ModuleDescriptor } from '../../common/general/module/brand-loader';
import { Theme } from '../../common/styles/general/theme';

export interface ModuleContextContent {
  basetheme: Theme;
  module: ModuleDescriptor;
}

export const ModuleContext = createContext<ModuleContextContent | undefined>(undefined);
